export default __webpack_public_path__ + "static/media/반려식물 화분 클래스 Mobile.0c6b43a3.jpg";